import { TopBanner } from '@repo/design-system-kit/components/top-banner/top-banner';
import { FormattedMessage } from 'react-intl';
import styles from './styles.module.css';

export function WelcomePromoBanner() {
  return (
    <TopBanner
      className={styles.welcomePromoBanner}
      data-test-welcome-promo-banner
      dismissable={false}
      type="info"
    >
      <FormattedMessage id="welcome.promo-banner.beglaubigt" />
    </TopBanner>
  );
}

export const welcomePromoBannerElement = <WelcomePromoBanner />;
